import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserSettings } from '../models/user-settings';
import { UserSettingsResponse } from '../models/user-settings-response';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userSettings$: BehaviorSubject<UserSettings | null> =
    new BehaviorSubject<UserSettings | null>(null);

  constructor(private http: HttpClient) {}

  initUserSettings() {
    this.userSettings$.subscribe(settings => {
      if (!settings) {
        this.getSettings();
      }
    });
  }

  public getUserSettings(): Observable<UserSettings | null> {
    return this.userSettings$.asObservable();
  }

  public updateUserSettings(command: any): Observable<any> {
    const url = `${environment.servicesApiUrl}/api/v3/user/settings`;

    return this.http.put<UserSettingsResponse>(url, command).pipe(
      tap(response => {
        this.userSettings$.next(response.userSettings);
      }),
    );
  }

  private getSettings() {
    const url = `${environment.servicesApiUrl}/api/v3/user/settings`;

    this.http.get<UserSettingsResponse>(url).subscribe((data: UserSettingsResponse) => {
      this.userSettings$.next(data.userSettings);
    });
  }
}
